import Footer from "../../components/Footer";
import TopHeader from "../../components/TopHeader";

const Cgv = () => {
  return (
    <>
      <TopHeader btn={true} />
      <div className="container mt-40 mb-80">
        <div className="col-md-8 mx-auto">
          <h2 className="grey500">Conditions Générales De Vente – C.G.V.</h2>
          <p className="body mt-14 grey66 bold500">
            <p>Dernière mise à jour : 16/06/2025</p>
          </p>
          <div className="mt-40">
            <h4 className="grey500 mt-24">C.G.V. Clients</h4>

            <ol>
              <h4 className="grey500 mt-40 mb-16">
                <li>Objet</li>
              </h4>
              <p className="body grey66">
                Les présentes CGV définissent les conditions de réservation et
                d&#39;achat de services par les Clients sur la plateforme TWYNY.
              </p>
              <h4 className="grey500 mt-40 mb-16">
                <li>Réservation</li>
              </h4>
              <p className="body grey66">
                Toute réservation effectuée via la plateforme implique
                l’acceptation des présentes CGV. Le Client s’engage à fournir
                des informations exactes et à respecter les conditions de
                réalisation du service.
              </p>
              <h4 className="grey500 mt-40 mb-16">
                <li>Paiement</li>
              </h4>
              <p className="body grey66">
                Le paiement est réalisé au moment de la réservation via un
                système sécurisé. Les moyens de paiement acceptés sont indiqués
                sur la plateforme. Une confirmation de réservation est transmise
                automatiquement par courriel.
              </p>
              <h4 className="grey500 mt-40 mb-16">
                <li>Frais de service &amp; Protections acheteurs</li>
              </h4>
              <p className="body grey66">
                Nous avons à cœur d’offrir un cadre de réservation sécurisé,
                fiable et transparent à chaque utilisateur. Les frais de service
                appliqués lors de chaque commande participent activement à la
                qualité de l’expérience, tout en intégrant une protection
                complète des acheteurs et une politique de remboursement claire.
              </p>
              <h3 className="mt-40 mb-16">Frais de service :</h3>
              <p className="body grey66 mb-10">
                Les frais de service financent les ressources indispensables au
                bon fonctionnement de la plateforme et à la sécurisation de vos
                transactions :
              </p>
              <ul>
                <li className="body grey66 mb-10 mt-13">
                  Infrastructure de paiement en ligne sécurisée
                </li>
                <li className="body grey66 mb-10 mt-13">
                  Garantie d’intervention en cas de litige ou d’annulation
                </li>
                <li className="body grey66 mb-10 mt-13">
                  Accès à un système de réservation fluide, intuitif et
                  performant
                </li>
                <li className="body grey66 mb-10 mt-13">
                  Support client réactif et personnalisé
                </li>
                <li className="body grey66 mb-10 mt-13">
                  Synchronisation en temps réel des disponibilités des
                  professionnels
                </li>
                <li className="body grey66 mb-10 mt-13">
                  Maintenance technique et amélioration continue de la
                  plateforme
                </li>
              </ul>
              <h3 className="mt-40 mb-16">Montant des frais :</h3>
              <p className="body grey66">
                Un frais de protection acheteur de 5,5% est appliqué au montant
                du service, en supplément du prix indiqué par le prestataire.
              </p>
              <h3 className="mt-40 mb-16">Protection des acheteurs :</h3>
              <p className="body grey66">
                Chaque réservation réalisée via Twyny est automatiquement
                couverte par notre protocole de protection acheteur.
              </p>
              <p className="body grey66 mt-13">Ce dispositif inclut :</p>
              <ul>
                <li className="body grey66 mb-10 mt-13">
                  Paiement sécurisé : le professionnel est rémunéré uniquement
                  après réalisation du service
                </li>
                <li className="body grey66 mb-10 mt-13">
                  Assistance proactive : accompagnement en cas d’annulation ou
                  de litige
                </li>
                <li className="body grey66 mb-10 mt-13">
                  Reprogrammation facilitée : proposition de nouvelles dates ou
                  d’un autre professionnel
                </li>
                <li className="body grey66 mb-10 mt-13">
                  Remboursement intégral si la prestation ne peut être honorée
                </li>
                <li className="body grey66 mb-10 mt-13">
                  Évaluations post-prestation pour garantir la qualité des
                  services référencés
                </li>
              </ul>
              <h4 className="grey500 mt-40 mb-16">
                <li>Annulation et remboursement</li>
              </h4>
              <p className="body grey66">
                Notre politique d&#39;annulation est conçue pour offrir une
                protection équitable aux clients comme aux prestataires de
                services en cas de changement de plan. Nous comprenons que des
                imprévus peuvent survenir, c&#39;est pourquoi nous avons mis en
                place des règles d&#39;annulation.
              </p>

              <p className="body grey66 mt-40">
                - **Avant confirmation du prestataire** : annulation gratuite
                par le client.
              </p>
              <p className="body grey66 mt-13">
               - **Annulation +48h avant la prestation** : remboursement de 94,5% (hors frais).
              </p>
              <p className="body grey66 mt-13">
              - **Annulation -48h avant la prestation** : pas de remboursement.
              </p>
              <p className="body grey66 mt-13">
                - **Absence du client à la date de la prestation** : pas de
                remboursement.
              </p>

              <p className="body grey66 mt-40">
                Les professionnels ne peuvent annuler une prestation réservée et
                confirmée que dans les cas où des circonstances imprévisibles ne
                permettent pas la réalisation du service. Dans ce cas, les
                utilisateurs sont automatiquement et intégralement remboursés de
                la valeur du service réservé.
              </p>
              <p className="body grey66 mt-16">
                Les professionnels peuvent aussi proposer de nouvelles dates
                pour réaliser la prestation auquel cas c’est l’utilisateur qui
                décide s’il accepte ou non de décaler la réalisation de
                l’activité. Si vous n’êtes pas disponible aux nouvelles dates
                proposées par le professionnel, vous serez intégralement
                remboursé de la valeur de la prestation réservée
              </p>
              <p className="body grey66 mt-16">
                - **Annulation par le prestataire** : remboursement intégral.
              </p>
              <p className="body grey66 mt-16">
                Les conditions spécifiques à chaque service sont affichées au
                moment de la réservation.
              </p>

              <h4 className="grey500 mt-40 mb-16">
                <li>Responsabilités</li>
              </h4>

              <p className="body grey66 mt-16">
                Le Client est seul responsable du choix du service et de sa
                bonne réalisation. TWYNY agit uniquement comme intermédiaire et
                ne peut être tenu responsable de l’exécution du service par le
                prestataire.
              </p>

              <h4 className="grey500 mt-40 mb-16">
                <li>Données personnelles</li>
              </h4>

              <p className="body grey66 mt-16">
                Les données sont traitées conformément à la charte de
                confidentialité de TWYNY, consultable sur :{" "}
                <a href="/politique-confidentialite">
                  https://twyny.com/politique-de-confidentialite
                </a>
              </p>

              <h4 className="grey500 mt-40 mb-16">
                <li>Réclamations</li>
              </h4>

              <p className="body grey66 mt-16">
                Pour toute demande ou litige, le Client peut écrire à
                support@twyny.com. Une médiation est possible si nécessaire.
              </p>
              <h4 className="grey500 mt-40 mb-16">
                <li>Droit applicable</li>
              </h4>

              <p className="body grey66 mt-16">
                Les CGV sont régies par le droit français. Tout litige relève de
                la compétence des juridictions de Paris.
              </p>
            </ol>

            <h4 className="grey500 mt-24">C.G.V. Partenaires</h4>
            <ol>
              <h4 className="grey500 mt-40 mb-16">
                <li>Objet</li>
              </h4>

              <p className="body grey66 mt-16">
                Les présentes CGV complètent les CGU et encadrent la relation
                commerciale entre Twyny (Eppox SAS) et les Partenaires utilisant
                la Plateforme pour proposer leurs services.
              </p>
              <h4 className="grey500 mt-40 mb-16">
                <li>Engagements du Partenaire</li>
              </h4>
              <p className="body grey66 mt-16">
                - Garantir la réalité, la disponibilité et la qualité des
                Services proposés.{" "}
              </p>
              <p className="body grey66 mt-16">
                {" "}
                - Disposer des compétences, autorisations et assurances
                nécessaires à l’exercice de son activité.
              </p>
              <p className="body grey66 mt-16">
                {" "}
                - Fournir à Twyny les informations exactes pour la facturation
                et l’encaissement.
              </p>
              <h4 className="grey500 mt-40 mb-16">
                <li>Acceptation des réservations</li>
              </h4>
              <p className="body grey66 mt-16">
                {" "}
                - Le Partenaire dispose de 48h maximum pour accepter ou refuser
                une demande.
              </p>

              <h4 className="grey500 mt-40 mb-16">
                <li>Tarification &amp; Paiement</li>
              </h4>
              <p className="body grey66 mt-16">
                - Twyny agit en tant que mandataire d’encaissement pour le
                compte du Partenaire.
              </p>
              <p className="body grey66 mt-16">
                - Les fonds sont reversés au Partenaire déduction faite de la
                commission Twyny au taux spécifique convenu selon la formule
                choisie.
              </p>
              <p className="body grey66 mt-16">
                - Paiement sous 14 jours ouvrés après réalisation effective de
                la prestation.
              </p>

              <h4 className="grey500 mt-40 mb-16">
                <li>Politique d&#39;annulation</li>
              </h4>
              <p className="body grey66 mt-16">
                - **Annulation par le Partenaire** : remboursement intégral au
                client.
              </p>
              <p className="body grey66 mt-16">
                - **Absence du Partenaire à la date de la prestation ** : pas de
                règlement
              </p>

              <h4 className="grey500 mt-40 mb-16">
                <li>Assurances</li>
              </h4>
              <p className="body grey66 mt-16">
                Le Partenaire s&#39;engage à détenir une assurance
                Responsabilité Civile Professionnelle couvrant l&#39;activité
                exercée sur la Plateforme. Il peut être demandé une preuve en
                cas de litige ou audit.
              </p>

              <h4 className="grey500 mt-40 mb-16">
                <li>Réclamations et médiation</li>
              </h4>
              <p className="body grey66 mt-16">
                En cas de litige avec un client :
              </p>
              <p className="body grey66 mt-16">
                - Le Partenaire est informé par Twyny.
              </p>
              <p className="body grey66 mt-16">
                - Un premier échange amiable est proposé via support@twyny.com.
              </p>
              <p className="body grey66 mt-16">
                - En cas d’échec, une médiation externe (plateforme ou médiateur
                désigné) pourra être proposée.
              </p>

              <h4 className="grey500 mt-40 mb-16">
                <li>Durée de conservation des données</li>
              </h4>
              <p className="body grey66 mt-16">
                Les logs, bons de réservation, factures et preuves de
                transaction sont conservés pendant 5 ans conformément à la
                législation fiscale et commerciale.
              </p>
              <h4 className="grey500 mt-40 mb-16">
                <li>Protection des données (RGPD)</li>
              </h4>
              <p className="body grey66 mt-16">
                La charte de confidentialité Twyny est consultable à l’adresse
                suivante :
                <a href="/politique-confidentialite">
                  https://twyny.com/politique-de-confidentalité
                </a>
              </p>
              <p className="body grey66 mt-16">
                Elle précise les droits d’accès, de rectification, de
                suppression et d’opposition au traitement des données
                personnelles.
              </p>
            </ol>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default Cgv;
